import type { ErrorCode } from '@pams/shared/constants';

/**
 * A known code, or any other string.
 *
 * `ErrorCode | string` would collapse to plain `string` and lose autocomplete entirely.
 * The `(string & {})` arm keeps the literal union suggestible while still accepting a
 * code this client has not been taught about — a proxy or a newer API can emit one, and
 * the client must not crash on it.
 */
export type ApiErrorCode = ErrorCode | (string & {});

export class ApiError extends Error {
  readonly code: ApiErrorCode;
  readonly status: number;
  readonly details?: unknown;

  constructor(status: number, code: ApiErrorCode, message: string, details?: unknown) {
    super(message);
    this.name = 'ApiError';
    this.status = status;
    this.code = code;
    this.details = details;
  }
}
